import React, {useState, useEffect} from 'react'
import { Form, Header,  Container, TableRow, TableBody, TableHeader, TableHeaderCell, Table, TableCell} from 'semantic-ui-react'
import { useFormik } from 'formik'
import { initialValues, validationSchema } from './InydeForm.form'
import { DZ } from '../../../../../api'
import { useAuth } from '../../../../../hooks'
import ConfirmWithReason from './ConfirmWiithReason'
import  {opcionesBaseAreas, opcionesBaseBase, opcionesBaseEnvase, piel, generos, familia} from './constants'
import "./InydeForm.scss";

const DZController = new DZ();

export function InydeDZForm(props) {
    const { onClose, onReload, DZ } = props;
    const { accessToken } = useAuth();
    const { user: { email, firstname, lastname } } = useAuth();
    const CorreoAsesor = email;
    const nombreCompleto = `${firstname} ${lastname}`;


    const [area, setArea] = useState(opcionesBaseAreas);
    const [base, setBase] = useState(opcionesBaseBase);
    const [envase, setEnvase] = useState(opcionesBaseEnvase);
    const [showConfirm, setShowConfirm] = useState(false);
    const [confirmMessage, setConfirmMessage] = useState("");
    const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState);
    
    const formik = useFormik({
        initialValues: initialValues(DZ),
        validationSchema: validationSchema(),
        validateOnChange: false,
        onSubmit: async (formValue) => {
            console.log("entro al submit");
            try {
                console.log("entro al try");
                const areaSeleccionados = formValue.area;
                const areaTexto = areaSeleccionados.join(', ');
                const data = {
                    asesor: CorreoAsesor,
                    asesornom: nombreCompleto,
                    base: formValue.base,
                    padecimiento: formValue.padecimiento,
                    area: areaTexto ? areaTexto : [],
                    activos: formValue.activos,
                    presentacion: formValue.presentacion,
                    envase: formValue.envase,
                    excel: formValue.excel,
                    costologrado: formValue.costologrado,
                    caducidad: formValue.caducidad,
                };
                
                if (DZ) {
                    await DZController.DZInyde(accessToken, DZ._id, data);
                } else {
                   console.log("Esto no deberia de pasar")
                }
                onClose();
                onReload();
            } catch (error) {
                console.error(error);
            }
        }
    });
    
    useEffect(() => {
       
        if (DZ?.area) {
            const valoresUnicos = [
                ...new Set([
                    ...opcionesBaseAreas.map((opt) => opt.value),
                    ...DZ.area.split(", ").filter(Boolean),
                ]),
            ];
            const opcionesCombinadas = valoresUnicos.map((valor) => ({
                key: valor,
                text: valor,
                value: valor,
            }));
            setArea(opcionesCombinadas);
        }
        if (DZ?.base) {
            const valoresUnicos = [
                ...new Set([
                    ...opcionesBaseBase.map((opt) => opt.value),
                    ...DZ.base.split(", ").filter(Boolean),
                ]),
            ];
            const opcionesCombinadas = valoresUnicos.map((valor) => ({
                key: valor,
                text: valor,
                value: valor,
            }));
            setBase(opcionesCombinadas);
        }
        if (DZ?.envase) {
            const valoresUnicos = [
                ...new Set([
                    ...opcionesBaseEnvase.map((opt) => opt.value),
                    ...DZ.envase.split(", ").filter(Boolean),
                ]),
            ];
            const opcionesCombinadas = valoresUnicos.map((valor) => ({
                key: valor,
                text: valor,
                value: valor,
            }));
            setEnvase(opcionesCombinadas);
        }
    }, [DZ]);

    const openDesactivateActivateConfirm = () => {
        setConfirmMessage(`Cancelar Formula DZ ${DZ.folio}`);
        onOpenCloseConfirm();
      }

    const handleCancel = async (reason) => {
    try {
        await DZController.CancelDzInyde(accessToken, DZ._id, reason)
        onClose();
        onReload();
        onOpenCloseConfirm();
    } catch (error) {
        console.error(error)
    }
    }

    const handleAddCustomOptionarea = (e) => {
        if (e.key === "Enter") {
            e.preventDefault(); // Evitar el envío del formulario en móviles.
            const newOption = formik.values.otroarea?.trim();
            if (newOption) {
                // Verificar si la opción ya existe en las opciones.
                if (!area.find((item) => item.value === newOption)) {
                    const updatedAreas = [...area, { key: newOption, text: newOption, value: newOption }];
                    setArea(updatedAreas);
                }
                // Asegurar que `formik.values.funciones` es un array válido.
                const currentAreas = formik.values.area || [];
                formik.setFieldValue("area", [...currentAreas, newOption]);
                formik.setFieldValue("otroarea", ""); // Resetear el input.
            }
        }
    };
    const handleAddCustomOptionbase = (e) => {
        if (e.key === "Enter") {
            e.preventDefault(); // Evitar el envío del formulario en móviles.
            const newOption = formik.values.otrobase?.trim(); // Validar si tiene valor antes de trim().
            if (newOption) {
                // Verificar si la opción ya existe en las opciones.
                if (!base.find((item) => item.value === newOption)) {
                    const updatedBases = [...base, { key: newOption, text: newOption, value: newOption }];
                    setBase(updatedBases); // Actualizar las opciones del dropdown.
                }
                // Establecer el nuevo valor como el valor seleccionado del dropdown.
                formik.setFieldValue("base", newOption);
                formik.setFieldValue("otrobase", ""); // Resetear el input.
            }
        }
    };
    const handleAddCustomOptionenvase = (e) => {
        if (e.key === "Enter") {
            e.preventDefault(); // Evitar el envío del formulario en móviles.
            const newOption = formik.values.otroenvase?.trim(); // Validar si tiene valor antes de trim().
            if (newOption) {
                // Verificar si la opción ya existe en las opciones.
                if (!envase.find((item) => item.value === newOption)) {
                    const updatedEnvase = [...envase, { key: newOption, text: newOption, value: newOption }];
                    setEnvase(updatedEnvase); // Actualizar las opciones del dropdown.
                }
                // Establecer el nuevo valor como el valor seleccionado del dropdown.
                formik.setFieldValue("envase", newOption);
                formik.setFieldValue("otroenvase", ""); // Resetear el input.
            }
        }
    };
    
    const onBlurarea = (e) => {
        const newOption = formik.values.otroarea?.trim();
        if (newOption) {
            if (!area.find((item) => item.value === newOption)) {
                const updatedAreas = [...area, { key: newOption, text: newOption, value: newOption }];
                setArea(updatedAreas);
            }
            const currentAreas = formik.values.area || [];
            formik.setFieldValue("area", [...currentAreas, newOption]);
            formik.setFieldValue("otroarea", ""); // Resetear el input.
        }
    }
    const onBlurbase = (e) => {
        const newOption = formik.values.otrobase?.trim(); // Validar si tiene valor antes de trim().
        if (newOption) {
            // Verificar si la opción ya existe en las opciones.
            if (!base.find((item) => item.value === newOption)) {
                const updatedBases = [...base, { key: newOption, text: newOption, value: newOption }];
                setBase(updatedBases); // Actualizar las opciones del dropdown.
            }
            // Establecer el nuevo valor como el valor seleccionado del dropdown.
            formik.setFieldValue("base", newOption);
            formik.setFieldValue("otrobase", ""); // Resetear el input.
        }
    }

    const onBlurenvase = (e) => {
        const newOption = formik.values.otroenvase?.trim(); // Validar si tiene valor antes de trim().
        if (newOption) {
            // Verificar si la opción ya existe en las opciones.
            if (!envase.find((item) => item.value === newOption)) {
                const updatedEnvases = [...envase, { key: newOption, text: newOption, value: newOption }];
                setEnvase(updatedEnvases); // Actualizar las opciones del dropdown.
            }
            // Establecer el nuevo valor como el valor seleccionado del dropdown.
            formik.setFieldValue("envase", newOption);
            formik.setFieldValue("otroenvase", ""); // Resetear el input.
        }
    }
   
    const date = new Date(DZ.created_at);
    const createdate = date.toLocaleDateString();

    const handleSave = async () => {
        try {
            console.log("entro al try")
            const areaSeleccionados = formik.values.area;
            const areaTexto = areaSeleccionados.join(', ');
            const data = {
                base: formik.values.base,
                padecimiento: formik.values.padecimiento,
                area: areaTexto ? areaTexto : [],
                activos: formik.values.activos,
                genero: formik.values.genero,
                nombre: formik.values.nombre,
                rangoedad: formik.values.rangoedad,
                tipopiel: formik.values.tipopiel,
                presentacion: formik.values.presentacion,
                envase: formik.values.envase,
                objetivo: formik.values.objetivo,
                excel: formik.values.excel,
                costologrado: formik.values.costologrado,
                caducidad: formik.values.caducidad
            }
    
            await DZController.saveDZOpe(accessToken, DZ._id, data)
            onClose();
            onReload();
            } catch (error) {
            console.error(error);
        }
    }
    return (
        <Form onSubmit={formik.handleSubmit} className='form'>
            <Container className='form-cotizacion__primer'>
                    <h3>{DZ.cancelmotivo && <p>Motivo de cancelación: <span>{DZ.cancelmotivo}</span></p>}</h3>
                    <h3>{DZ.backmotivo && <p>Motivo de regreso: <span>{DZ.backmotivo}</span></p>}</h3>
                <Form.Group className="form-group">
                    <p>Asesor: <span>{nombreCompleto}</span></p>
                    <p>Fecha: <span>{createdate}</span></p>
                </Form.Group>
                <Form.Input readOnly label="Nombre del producto" name="nombre" placeholder="Nombre del producto" onChange={formik.handleChange} value={formik.values.nombre} error={formik.errors.nombre} />
                <Form.Group className="form-group">
                    <Form.Input readOnly label="Familia" name="familia" placeholder="" onChange={formik.handleChange} value={formik.values.familia} error={formik.errors.familia} />
                    <Form.Input readOnly label="Rango de edad" name="rangoedad" placeholder="Rango de edad" onChange={formik.handleChange} value={formik.values.rangoedad} error={formik.errors.rangoedad} />
                </Form.Group>
                <Form.Group className="form-group">
                    <Form.Input readOnly label="Género" name="genero" placeholder="" onChange={formik.handleChange} value={formik.values.genero} error={formik.errors.genero} />
                    <Form.Input readOnly label="Tipo de piel" name="tipopiel" placeholder="" onChange={formik.handleChange} value={formik.values.tipopiel} error={formik.errors.tipopiel} />
                </Form.Group>
                {// A que area del cuerpo va dirigida
                }
                <Form.Dropdown label="¿A qué área del cuerpo va dirigida?" placeholder="Seleccione las opciones" fluid selection multiple options={area}
                 onChange={(_, data) => formik.setFieldValue("area", data.value)} value={formik.values.area || []} error={formik.errors.area} />
                 <Form.Input
                label="Otro(s)"
                name="otroarea"
                placeholder="Otra área que no está en la lista."
                onChange={formik.handleChange}
                onKeyDown={handleAddCustomOptionarea}
                onBlur={onBlurarea}
                value={formik.values.otroarea}
                error={formik.errors.otroarea}
                />
                {// base del producto
                }
                <Form.Dropdown label="Base del producto" placeholder="Seleccione la base" fluid selection options={base}
                 onChange={(_, data) => formik.setFieldValue("base", data.value)} value={formik.values.base || []} error={formik.errors.base} />
                 <Form.Input
                label="Otro(s)"
                name="otrobase"
                placeholder="Otra base que no está en la lista."
                onChange={formik.handleChange}
                onKeyDown={handleAddCustomOptionbase}
                onBlur={onBlurbase}
                value={formik.values.otrobase}
                error={formik.errors.otrobase}
                />
                <Form.TextArea  label="Padecimiento" name="padecimiento" placeholder="padecimiento..." onChange={formik.handleChange} value={formik.values.padecimiento} error={formik.errors.padecimiento} />
                <Form.TextArea label='Ingredientes/Activos' name='activos' onChange={formik.handleChange} value={formik.values.activos} error={formik.errors.activos} />
                <Form.Dropdown label="Tipo de Envase" placeholder="Seleccione el envase" fluid selection options={envase}
                 onChange={(_, data) => formik.setFieldValue("envase", data.value)} value={formik.values.envase || []} error={formik.errors.envase} />
                 <Form.Input
                label="Otro(s)"
                name="otroenvase"
                placeholder="Otro envase que no está en la lista."
                onChange={formik.handleChange}
                onKeyDown={handleAddCustomOptionenvase}
                onBlur={onBlurenvase}
                value={formik.values.otroenvase}
                error={formik.errors.otroenvase}
                />
                <Form.Input  readOnly label="Presentación del producto (ml)" name="presentacion" placeholder="Presentacion del producto" onChange={formik.handleChange} value={formik.values.presentacion} error={formik.errors.presentacion} />
                <Container className='precio_unitario'>
                <Table className='table-precio' celled>
                    <TableHeader>
                        <TableRow>
                        
                        <TableHeaderCell>Presupuesto por KG</TableHeaderCell>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        <TableRow>
            
                        <TableCell>{DZ.presupuesto}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
                </Container>
                <br></br>
                <Container className='precio_unitario'>
                    <Table className='table-precio' celled>
                        <TableHeader>
                            <TableRow>
                   
                            <TableHeaderCell>Costo por KG logrado</TableHeaderCell>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            <TableRow>
                       
                            <TableCell><Form.Input name='costologrado' placeholder='0' onChange={(e) => {formik.setFieldValue('costologrado', e.target.value.replace(/[^0-9]/g, ''))}} value={formik.values.costologrado} error={formik.errors.costologrado} /></TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </Container>
                <br></br>
                <Form.Input label="Caducidad (meses)" name="caducidad" placeholder="0" onChange={(e) => {formik.setFieldValue('caducidad', e.target.value.replace(/[^0-9]/g, ''))}} value={formik.values.caducidad} error={formik.errors.caducidad} />
                <br></br>
               </Container>
               <a target='blank' href='https://omicron1ab-my.sharepoint.com/:x:/g/personal/fernanda_gomez_o-lab_mx/EaNzYIMkB0JFkfeDf2ESb6QBvyTrr3FjHuRiUxuOi1QW8Q?e=agFtPu&wdOrigin=TEAMS-MAGLEV.p2p_ns.rwc&wdExp=TEAMS-TREATMENT&wdhostclicktime=1732632119525&web=1'>
                    <Header
                 className='center' color='green'>Excel de datos</Header>
                 </a>
                 <Form.Checkbox label='Excel' name='excel' onChange={(_, data) => formik.setFieldValue("excel", data.checked)}
                checked={formik.values.excel} error={formik.errors.excel} className='custom-checkbox' />
               <br></br>
            <Container>
                <Form.Button type='button' primary fluid onClick={handleSave} loading={formik.isSubmitting}>
                    Guardar
                </Form.Button>
                <Form.Button type='submit' primary fluid loading={formik.isSubmitting} >
                    Enviar Cotización
                </Form.Button>
                <Form.Button type='button' color='red' fluid onClick={openDesactivateActivateConfirm}>
                    Cancelar
                </Form.Button>
                <ConfirmWithReason open={showConfirm} onCancel={onOpenCloseConfirm} onConfirm={handleCancel} content={confirmMessage} size='mini'></ConfirmWithReason>
            </Container>
        </Form>
    )
}
